/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { action, observable } from 'mobx';
import { v4 } from 'uuid';
import { Notification, NotificationState } from './types';

export class Notifications {
  @observable queue: Notification[] = [];
  @observable active: NotificationState = {
    item: null,
    open: false
  };

  @action.bound
  enqueueNotification(notification: Notification): void {
    this.queue.push(notification);

    if (this.active.open) {
      this.hideCurrentNotification();
    } else {
      this.processQueue();
    }
  }

  @action.bound
  hideCurrentNotification(): void {
    this.active.open = false;
  }

  @action.bound
  showNextNotification(): void {
    this.processQueue();
  }

  @action.bound
  processQueue(): void {
    if (this.queue.length > 0) {
      this.active = {
        item: this.getNextNotification(),
        open: true,
        key: v4()
      };
    }

    // Remove leftovers
    if (!this.active.open && this.active.item) {
      this.active = {
        item: null,
        open: false
      };
    }
  }

  getNextNotification(): Notification | null {
    return this.queue.shift() || null;
  }

  enqueueDefaultSuccess = (message: string): void => {
    this.enqueueNotification({
      message,
      type: 'success'
    });
  };

  enqueueDefaultError = (message: string): void => {
    this.enqueueNotification({
      message,
      type: 'error'
    });
  };
}
